module.exports = __webpack_public_path__ + "img/next.e692a03e.svg";